/* src/app/modules/concept/orders/orders-create.component.css */
.oc-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.oc-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 16px;
}
.oc-loading__icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: var(--cf-brand, #e3fd64);
  opacity: 0.6;
}
.oc-loading__text {
  margin: 0;
  font-size: 0.875rem;
  color: var(--cf-text-muted, #6b7280);
}
.oc-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.oc-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.oc-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.oc-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.oc-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.oc-btn-back {
  margin-left: auto;
  border-radius: 8px !important;
  white-space: nowrap;
}
.oc-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.oc-btn-save:hover {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.oc-body {
  padding: 14px 20px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 768px) {
  .oc-header {
    padding: 10px 14px;
  }
  .oc-body {
    padding: 10px 12px;
  }
}
.oc-section {
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  overflow: hidden;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0,0,0,0.08));
}
.oc-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  background: var(--cf-bg, #f4f6f8);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--cf-text, #1a1d23);
}
.oc-section__head mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
  color: var(--cf-brand, #e3fd64);
  flex-shrink: 0;
}
.oc-section__badge {
  margin-left: auto;
  background: rgba(227, 253, 100, 0.15);
  color: var(--cf-brand-dark, #4d7a00);
  font-size: 0.72rem;
  font-weight: 700;
  padding: 1px 8px;
  border-radius: 10px;
}
.oc-section__body {
  padding: 12px 14px;
}
.oc-section__body--table {
  padding: 0;
}
.oc-provider-name {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--cf-text, #1a1d23);
}
.oc-table-wrap {
  overflow-x: auto;
}
.oc-table {
  width: 100%;
  min-width: 560px;
}
.oc-table .mat-mdc-header-cell {
  background: var(--cf-bg, #f4f6f8);
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cf-text-muted, #6b7280);
  padding: 10px 16px;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.oc-table .mat-mdc-cell {
  padding: 10px 16px;
  font-size: 0.875rem;
  color: var(--cf-text, #1a1d23);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.oc-table .mat-mdc-row:last-child .mat-mdc-cell {
  border-bottom: none;
}
.oc-table .mat-mdc-row:hover .mat-mdc-cell {
  background: rgba(227, 253, 100, 0.04);
}
.oc-col-right {
  text-align: right !important;
}
.oc-col-total {
  font-weight: 600;
  color: var(--cf-brand-dark, #4d7a00) !important;
}
.oc-qty-input {
  width: 72px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 6px;
  font-size: 0.875rem;
  text-align: right;
  background: #fff;
  outline: none;
  transition: border-color 0.15s;
}
.oc-qty-input:focus {
  border-color: var(--cf-brand, #e3fd64);
}
.oc-qty-input:disabled {
  background: var(--cf-bg, #f4f6f8);
  color: var(--cf-text-muted, #6b7280);
  cursor: not-allowed;
}
.oc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 48px 20px;
  color: var(--cf-text-muted, #9ca3af);
}
.oc-empty mat-icon {
  font-size: 40px;
  width: 40px;
  height: 40px;
  opacity: 0.4;
}
.oc-empty p {
  margin: 0;
  font-size: 0.875rem;
}
/*# sourceMappingURL=orders-create.component.css.map */
